export default "/images/vendor/flag-icon-css/flags/1x1/es.svg?ab57bf70f93a708e0107e83d3baf07f3";